<template>
    <div class="row">
        <div class="col-md-12">
            <div class="tabs__content" v-if="loading" :class="{'d-flex': !list.length}">

                <template v-if="list.length">
                    <div class="product product--tabs-row d-flex" v-for="item in list">
                        <div class="product__thumbnail">
                            <img v-if="item.avatar"
                                 :src="'/storage' + (item.avatar.path.replace('original', 'preview_l'))"
                                 :alt="item.name">
                        </div>
                        <div class="product-desc product-edit">
                            <a :href="'/pets/' + item.id" class="product_title">
                                <h4>{{ item.name }}</h4>
                            </a>

                            <div class="product__tabs-info d-flex">

                                <div class="product__labels d-flex">
                                    <span v-if="typeof item.is_moderated === 'number'" class="product__label"
                                          :class="(+item.is_moderated === 0) ? 'product__label--created' : (+item.is_moderated === 1) ? 'product__label--approve' :
                                                   (+item.is_moderated === 2) ? 'product__label--moderate' : (+item.is_moderated === 3) ? 'product__label--rejected' : null">
                                        {{ (+item.is_moderated === 0) ? 'Создан' : (+item.is_moderated === 1) ? 'Одобрен' :
                                        (+item.is_moderated === 2) ? 'На модерации' : (+item.is_moderated === 3) ? 'Отказано' : null }}
                                    </span>

                                    <span class="product__label" v-if="item.status === 0">В архиве</span>
                                </div>


                            </div>

                            <div class="product__actions d-flex">
                                <template v-if="item.status === 1 || (item.status === 0 && item.archive_reason !== 'died')">
                                    <a class="btn btn-sm btn--round" :href="'/publication/personal_pet/' + item.id">
                                        Редактирование
                                    </a>
                                </template>
                            </div>

                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="empty-list">
                        Подопечных еще нет
                    </div>
                </template>

            </div>
            <div class="tabs__content d-flex" v-else>
                <div  class="profile-pets__body-content d-flex">
                    <div class="LoaderBalls">
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                    </div>
                </div>
            </div>

        </div>


        <div class="col-md-12">
            <div class="row" v-if="pets.pageCount > 1">
                <div class="col-md-12">
                    <div class="pagination-area">
                        <nav class="navigation pagination" role="navigation">
                            <div class="nav-links">
                                <paginate
                                    v-model="page"
                                    :page-count="pets.pageCount"
                                    :click-handler="paginateClickCallback"
                                    :prev-text="''"
                                    :next-text="''"
                                    :container-class="'className'"
                                    :page-class="'page-numbers'"
                                    :page-link-class="''"
                                    :active-class="'current'"
                                    :prev-class="'prev page-numbers'"
                                    :prev-link-class="'lnr lnr-arrow-left'"
                                    :next-class="'next page-numbers'"
                                    :next-link-class="'lnr lnr-arrow-right'"
                                >
                                </paginate>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "UserClassifiedsPetsArchive",
    props: ['user', 'pets'],
    data(){
        return{
            moment: window.moment,
            loading: true,
            page: 1,
        }
    },

    mounted(){
        this.loading = false
    },

    watch:{
        list(){
            this.loading = false

            setTimeout(()=>{
                this.loading = true
            },1000)

        }
    },

    computed:{
        list(){

            let arr = []

            if(this.pets.list.length) {
                arr = this.pets.list

                setTimeout(()=>{
                    this.loading = true
                },1000)

            }

            return arr

        }
    },

    methods:{

        paginateClickCallback(pageNum) {
            this.page = pageNum
            this.$emit('pagination', this.page);
        },


    }


}
</script>

<style lang="scss" scoped>
.product-edit{
    padding: 0;
    .product__actions{
        margin: 0 -5px;
        flex-wrap: wrap;
        .btn{
            margin: 5px;
        }
    }
}

.item-actions {
    font-size: 0.9rem;
    padding: 5px 0;
}
.empty-list{
    font-size: 32px;
    font-weight: 700;
    text-align: center;
    height: 100%;
    display: flex;
    flex-grow: 1;
    width: 100%;
    justify-content: center;
    align-items: center;
}

.tabs__filters{
    padding: 18px 47px 0;

    .custom-options{
        top: 100%;
    }

    .custom-select-wrapper{
        width: 250px;
        margin-right: 30px;

        &:last-child{
            margin-right: 0;
        }

    }

}

.profile-pets__body-content{
    min-height: unset;
}

.tabs__content{
    min-height: 300px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.product--tabs-row{
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 20px 0 16px;
    border-bottom: 1px solid #ececec;
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 0;
    width: 100%;
    &:last-child{
        border-bottom: none;
    }
}

.product--tabs-row .product__thumbnail{
    width: 60px;
    height: 60px;
    line-height: 60px;
    margin-right: 30px;
    flex-shrink: 0;
    border-radius: 50%;
    overflow: hidden;
}

.product--tabs-row .product__thumbnail img{
    width: 100%;
    height: auto;
}

.product--tabs-row .product-desc{
    position: relative;
    padding: 0 30px 0 0 ;
    flex-grow: 1;
}

.product--tabs-row .product_title{


    h4{
        margin-bottom: 0;
    }
}
.product-text{
    margin-top: 15px;
}
.product__tabs-info{
    align-items: center;
    margin-bottom: 15px;
}

.product__label{
    font-weight: bold;
    font-size: 10px;
    line-height: 24px;
    padding: 0 10px;
    border-radius: 3px;
    display: inline-block;
    margin: 5px 20px 5px 0;
    color: #91DA66;
    background: #F4FBF0;

    &--created{
        color: #17a2b8;
        background: #F4FBF0;
    }

    &--moderate{
        color: #F6C143;
        background: #F4FBF0;
    }

    &--rejected{
        color: #EE7372;
        background: #FEF1F1;
    }

    &--approve{
        color: #91DA66;
        background: #F4FBF0;
    }
}

.product__reasons li{
    position: relative;
    font-size: 12px;
    line-height: 140%;
    color: #555555;
    padding-left: 14px;
    display: inline-block;
    margin: 5px 20px 5px 0;
    &::before{
        position: absolute;
        display: block;
        content: "";
        left: 0;
        top: 50%;
        width: 8px;
        height: 8px;
        background: #EE7372;
        border-radius: 50%;
        transform: translateY(-50%);
    }

}

.product__actions .btn{
    display: inline-block;
    padding: 10px 32px;
    font-weight: bold;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    border-radius: 45px;
    transition: opacity 0.2s ease;
    margin: 5px 0;
}


.product--tabs-row .product-desc .prod_option{
    left: unset;
    right: 0;
    top: 0;
}

.product--tabs-row .product-desc .prod_option .setting-icon{
    width: 25px;
    line-height: 25px;
    height: 25px;
    font-size: 14px;
}

.product--tabs-row .product-desc .prod_option .options{
    transform: translate3d(0px, 22px, 0px) !important;
    top: 10px !important;
    right: 0 !important;
    left: auto !important;

    &::before{
        left: unset;
        right: 10px;
    }
}

.time{
    font-weight: 300;
    font-size: 12px;
    line-height: 20px;
    color: #929292;
    margin-top: 18px;

    span{
        color: #555555;
    }
}

.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        // .LoaderBalls__wrapper__item
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6,.05,.15,.95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}



@media screen and (max-width: 992px){
    .product__tabs-info{
        flex-wrap: wrap;
    }
}


@media screen and (max-width: 768px){
    .empty-list{
        font-size: 22px;
    }
    .tabs__content{
        padding: 18px 20px 0;
    }

    .product--tabs-row{
        flex-direction: column;
        align-items: center;
    }

    .product--tabs-row .product__thumbnail{
        width: 100px;
        height: 100px;
        margin-bottom: 20px;
        margin-right: 0;
    }
    .product--tabs-row .product-desc{
        width: 100%;
    }

    .product__tabs-info{
        flex-direction: column;
        align-items: flex-start;
    }

    .tabs__filters .custom-select-wrapper{
        width: 100%;
        margin-right: 0;
        margin-bottom: 15px;

        &:last-child{
            margin-bottom: 0;
        }
    }
}

</style>
